var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2055 3.5376H16.7948C16.5805 3.5376 16.4734 3.64474 16.4734 3.85903V16.4751H4.50112C4.28683 16.4751 4.17969 16.5822 4.17969 16.7965V19.2072C4.17969 19.4215 4.28683 19.5287 4.50112 19.5287H16.4734V32.1447C16.4734 32.359 16.5805 32.4662 16.7948 32.4662H19.2055C19.4198 32.4662 19.527 32.359 19.527 32.1447V19.5287H31.5011C31.7154 19.5287 31.8225 19.4215 31.8225 19.2072V16.7965C31.8225 16.5822 31.7154 16.4751 31.5011 16.4751H19.527V3.85903C19.527 3.64474 19.4198 3.5376 19.2055 3.5376Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomPlus);
export default __webpack_public_path__ + "static/media/zoomPlus.5b7d9a569a9ae507f3a6e231753e088f.svg";
export { ForwardRef as ReactComponent };